import type { AttentionCardAppointmentCaseModel } from '@components/attention_card/_attention_card.controller';
import { I18nAndL10n } from '@modules/i18n_and_l10n/mod';
import { withTranslation } from '@modules/i18n_and_l10n/with_translation';
import { DateService } from '@services/date.service';
import { useService } from '@visiba/instantiation';
import { AttentionCardCaseCardAppointment } from './_attention_card_case_card_appointment.component';
import { getAppointmentParticipantsText } from './_get_appointment_participant_text';

interface Props {
	case: AttentionCardAppointmentCaseModel;
}

export function AttentionCardTypeUpcomingAppointments({ case: $case }: Props): JSX.Element {
	const dateService = useService(DateService);

	let description: string;
	if (dateService.isToday($case.dateInstance)) {
		description = withTranslation('Common.Word.Today');
	} else if (dateService.isTomorrow($case.dateInstance)) {
		description = withTranslation('Common.Word.Tomorrow');
	} else {
		description = $case.dateFormatted;
	}

	const participantsText = getAppointmentParticipantsText($case);
	const ariaLabel = I18nAndL10n.translate('PW.Component.AttentionCard.UpcomingAppointment.Aria', {
		participants: participantsText,
		unitName: $case.receptionName,
		dateTime: $case.dateFormatted,
	});

	return (
		<AttentionCardCaseCardAppointment
			case={$case}
			description={description}
			analyticAction='Clicked Next appointment-card'
			ariaLabel={ariaLabel}
		/>
	);
}
